import React from 'react';
import { useGeolocation } from '@this/lib/hooks/useGeoLocation';

// custom hookをクラスコンポーネントで使用できないので、一時的にadapterを作成。
// 関数型にしたら、useGeolocationを直接使用すること。
export interface GeolocationProps {
  isLoadingCurrentPlace: boolean;
  geolocationError: string | null;
  formattedAddress: string | null;
  getCurrentPlace: (e?: React.MouseEvent<HTMLAnchorElement>) => Promise<{
    formattedAddress: string;
    fullAddress: string;
    coordinates: { latitude: number; longitude: number };
  }>;
}

export const withGeolocation = <P extends GeolocationProps>(WrappedComponent: React.ComponentType<P>) => {
  type HocProps = Omit<P, keyof GeolocationProps>;

  const GeolocationAdapter: React.FC<HocProps> = props => {
    const { loading, error, formattedAddress, getCurrentPlace } = useGeolocation();

    const geolocationProps: GeolocationProps = {
      isLoadingCurrentPlace: loading,
      geolocationError: error,
      formattedAddress,
      getCurrentPlace
    };

    return <WrappedComponent {...(props as any)} {...geolocationProps} />;
  };

  return GeolocationAdapter;
};
